'use strict';

var React = require('react');

function _interopNamespaceDefault(e) {
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n.default = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgHeroCar = function SvgHeroCar(props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M812.8 953.6c0 38.4-134.4 70.4-300.8 70.4s-300.8-32-300.8-73.6C211.2 912 345.6 880 512 880s300.8 32 300.8 73.6M995.2 240v48c0 9.6-6.4 16-16 16l-51.2 3.2c-9.6 0-16 6.4-16 16l-16 371.2c0 6.4-9.6 16-19.2 16H774.4c-9.6 0-22.4-9.6-22.4-19.2V592c0-9.6-6.4-16-16-16-73.6 6.4-150.4 9.6-224 9.6-76.8 0-150.4-3.2-224-9.6-9.6 0-16 6.4-16 16v99.2c0 9.6-12.8 19.2-22.4 19.2H147.2c-12.8 0-19.2-6.4-19.2-16l-16-371.2c0-9.6-6.4-16-16-16L44.8 304c-9.6 0-16-6.4-16-16v-48c0-9.6 6.4-16 16-16h89.6c6.4 0 16-6.4 16-16 6.4-32 35.2-86.4 48-115.2 16-25.6 48-92.8 144-92.8h339.2c96 0 128 67.2 140.8 92.8 12.8 28.8 41.6 83.2 48 115.2 3.2 9.6 9.6 16 19.2 16h89.6c9.6 0 16 6.4 16 16M368 374.4c0-35.2-12.8-60.8-86.4-60.8-64 0-67.2 28.8-67.2 60.8s25.6 51.2 67.2 51.2c44.8 0 86.4-19.2 86.4-51.2m144-147.2c144 0 259.2 6.4 259.2 6.4s-16-54.4-32-86.4C710.4 92.8 668.8 96 640 96H390.4c-32 0-73.6 0-99.2 51.2-19.2 32-32 86.4-32 86.4s108.8-6.4 252.8-6.4m297.6 147.2c0-35.2-3.2-60.8-67.2-60.8-73.6 0-86.4 28.8-86.4 60.8s38.4 51.2 86.4 51.2c44.8 0 67.2-19.2 67.2-51.2"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCar);

module.exports = ForwardRef;
